import axios from "axios";
import Config from "../Configuration/server";

export const getPageContent = async () => {
  try {
    const result = await axios(
      `${Config.UMBRACO_CONTENT}/api/Hadracha/GetHadracha`,
      {
        method: "GET",
        headers: {
          "Ocp-Apim-Subscription-Key": Config["Ocp-Apim-Subscription-Key"],
        },
      }
    );
    return result.data;
  } catch (error) {}
};
